export const calculateTimeToRead = (timeToRead: number): string =>
  `${Math.round(timeToRead / 60)} min read`;
